'use client';

/** Shown when the page cannot be rendered, typically because the database is unreachable. */
export default function ErrorPage({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <main className="fallback">
      <h1>The comparison is unavailable right now.</h1>
      <p>We could not reach the price data. Try again in a moment.</p>
      <button type="button" onClick={reset}>
        Try again
      </button>
    </main>
  );
}
